module.exports = __webpack_public_path__ + "img/allegiant-stadium-buyout-gal-11.46b3882a.jpg";